import axiosInstance from "./AxiosInstance";

export function getTractorModelList(data) {
    return axiosInstance.post(`tractor-model`, data);
}

export function getTractorTiresList(data) {
    return axiosInstance.post(`tractor-tires`, data);
}

export function getTractorUpgradesList(data) {
    return axiosInstance.post(`tractor-upgrades`, data);
}

export function getTractorAttachmentsList(data) {
    return axiosInstance.post(`tractor-attachments`, data);
}

export function getTractorEquipmentList(data) {
    return axiosInstance.post(`tractor-equipment`, data);
}

export function getTractorAccessoriesList(data) {
    return axiosInstance.post(`tractor-accessories`, data);
}

export function getCountriesList(data) {
    return axiosInstance.post(`countries`, data);
}

export function getStatesList(data) {
    return axiosInstance.post(`states`, data);
}

export function getDealersList(data) {
    return axiosInstance.post(`dealers`, data);
}

export function getOffersList(data) {
    return axiosInstance.post(`offers`, data);
}

export function createCustomerInquiry(data) {
    return axiosInstance.post(`customer-inquiry`, data);
}

export function getDownloadPdf(data) {
    return axiosInstance.post(`download-pdf`, data);
}

export function getEmailConfiguration(data) {
    return axiosInstance.post(`email-configuration`, data);
}
export function getDealerId(data) {
    return axiosInstance.post(`get-dealer-id`, data);
}
